import { render, staticRenderFns } from "./Table-Contabil.vue?vue&type=template&id=6a299f62&"
import script from "./Table-Contabil.vue?vue&type=script&lang=js&"
export * from "./Table-Contabil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Table-Contabil.vue"
export default component.exports